import './ShareButton.css';
import { FaWhatsapp } from "react-icons/fa";
import { useSettings } from "../Context/SettingsContext";

function ShareButton({reference})
{    
    const settings = useSettings();

    const message = encodeURIComponent(
        `¡Hola Laurelia! ` +
        `Me interesa este producto: ${settings.BaseURL}/product/${reference} `
      );

      const whatsappUrl = `https://wa.me/${settings.BusinessPhone}?text=${message}`;

      return (
        <div>
          <button
            onClick={() => window.open(whatsappUrl, "_blank")}
            className="share-button"
          >
            <FaWhatsapp size={20} style={{ marginRight: "8px" }} />
            ¡Quiero este producto!
          </button>
        </div>
      );

}

export { ShareButton };